import { HttpHeaders, HttpParams } from "@angular/common/http";
import { BdpkConfigService } from "../../bdpk-common/services/bdpk-config.service";
import { DxObjectMapper } from "../../dx-core/services/dx-object-mapper.service";
import { DxHttpDispatcher } from "../../dx-core/services/dx-http-dispatcher.service";
import { map, take } from "rxjs/operators";
import { PitUser } from "../domain/pit-user";
import * as i0 from "@angular/core";
import * as i1 from "../../bdpk-common/services/bdpk-config.service";
import * as i2 from "../../dx-core/services/dx-object-mapper.service";
import * as i3 from "../../dx-core/services/dx-http-dispatcher.service";
/**
 *  Service corresponding with users-service server endpoint
 */
export class PitUsersService {
    constructor(_configService, _mapper, _http) {
        this._configService = _configService;
        this._mapper = _mapper;
        this._http = _http;
        this.usOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8'),
            observe: "response"
        };
        this.usContext = this._configService.pitBackendUsersEndPoint;
    }
    getUsers(showLocked = false) {
        return this._http.get(`${this.usContext}/`, Object.assign({}, this.usOptions, { params: new HttpParams().append('showLocked', String(showLocked)) }))
            .pipe(take(1), map((response) => {
            return this._mapper.deserializeASArray(response.body, PitUser);
        }));
    }
}
PitUsersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PitUsersService_Factory() { return new PitUsersService(i0.ɵɵinject(i1.BdpkConfigService), i0.ɵɵinject(i2.DxObjectMapper), i0.ɵɵinject(i3.DxHttpDispatcher)); }, token: PitUsersService, providedIn: "root" });
